/**
 function 관련 유틸리티
 @packageDocumentation
 */

/**
 * wrap function
 * @param originFn origin function
 * @param wrapProcFn wrap proc
 *
 * ```typescript
 * wrap(originFunction, (next, ...args) => {
 *  // action before something
 *  // execute originFunction
 *  next()
 *  // action after something
 * })
 * ```
 */
export const wrap = function (originFn: Function, wrapProcFn: (next: Function) => any | void): Function {
  const backupFn = originFn
  originFn = function () {
    const args = Array.from(arguments)

    const nextFn: Function = function () {
      if (backupFn) {
        return backupFn.apply(this, arguments)
      }
    }.bind(this, ...args)

    return wrapProcFn.apply(this, [nextFn, ...args])
  }

  return originFn
}

/**
 * promise 객체 여부 판단
 * @param obj
 */
export const isPromise = obj => {
  return obj instanceof Promise || (obj && typeof obj.then === 'function')
}
